/* ------------ -------------- ------------*/
/* ------------  Validate Form ------------*/
/* ------------ -------------- ------------*/

export default  (values) =>{

    const errors = {}
    if (!values.username) {
        errors.username = 'این فیلد اجباری می باشد'
    }

    if (!values.password) {
        errors.password = 'رمز عبور اجباری میباشد'
    }

    return errors
};